/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
} from './Direction';
import type { LookupMappings } from './LookupMappings';
import {
    LookupMappingsFromJSON,
    LookupMappingsFromJSONTyped,
    LookupMappingsToJSON,
} from './LookupMappings';
import type { PromptGroups } from './PromptGroups';
import {
    PromptGroupsFromJSON,
    PromptGroupsFromJSONTyped,
    PromptGroupsToJSON,
} from './PromptGroups';

/**
 * A revision of a prompt for contact summarisation
 * @export
 * @interface GetPublishedPromptRevisionResponseContent
 */
export interface GetPublishedPromptRevisionResponseContent {
    /**
     * Fixed Prompt Hash Key
     * @type {string}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    promptHashKey: string;
    /**
     * Name of the prompt revision
     * @type {string}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    name: string;
    /**
     * 
     * @type {PromptGroups}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    promptGroups: PromptGroups;
    /**
     * 
     * @type {LookupMappings}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    queueIds?: LookupMappings;
    /**
     * 
     * @type {Direction}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    initialDirection?: Direction;
    /**
     * 
     * @type {number}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    duration?: number;
    /**
     * The time at which the resource was created
     * @type {number}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    createdAt: number;
    /**
     * The time of the most recent update
     * @type {number}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    updatedAt: number;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    createdBy: CallingIdentity;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    updatedBy: CallingIdentity;
    /**
     * Identifier for the prompt revision
     * @type {string}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    promptRevisionId: string;
    /**
     * Original prompt ID used when setting the ID as the published prompt
     * @type {string}
     * @memberof GetPublishedPromptRevisionResponseContent
     */
    originalPromptRevisionId?: string;
}


/**
 * Check if a given object implements the GetPublishedPromptRevisionResponseContent interface.
 */
export function instanceOfGetPublishedPromptRevisionResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "promptHashKey" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "promptGroups" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "updatedBy" in value;
    isInstance = isInstance && "promptRevisionId" in value;

    return isInstance;
}

export function GetPublishedPromptRevisionResponseContentFromJSON(json: any): GetPublishedPromptRevisionResponseContent {
    return GetPublishedPromptRevisionResponseContentFromJSONTyped(json, false);
}

export function GetPublishedPromptRevisionResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPublishedPromptRevisionResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'promptHashKey': json['promptHashKey'],
        'name': json['name'],
        'promptGroups': PromptGroupsFromJSON(json['promptGroups']),
        'queueIds': !exists(json, 'queueIds') ? undefined : LookupMappingsFromJSON(json['queueIds']),
        'initialDirection': !exists(json, 'initialDirection') ? undefined : DirectionFromJSON(json['initialDirection']),
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'createdBy': CallingIdentityFromJSON(json['createdBy']),
        'updatedBy': CallingIdentityFromJSON(json['updatedBy']),
        'promptRevisionId': json['promptRevisionId'],
        'originalPromptRevisionId': !exists(json, 'originalPromptRevisionId') ? undefined : json['originalPromptRevisionId'],
    };
}

export function GetPublishedPromptRevisionResponseContentToJSON(value?: GetPublishedPromptRevisionResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'promptHashKey': value.promptHashKey,
        'name': value.name,
        'promptGroups': PromptGroupsToJSON(value.promptGroups),
        'queueIds': LookupMappingsToJSON(value.queueIds),
        'initialDirection': DirectionToJSON(value.initialDirection),
        'duration': value.duration,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'createdBy': CallingIdentityToJSON(value.createdBy),
        'updatedBy': CallingIdentityToJSON(value.updatedBy),
        'promptRevisionId': value.promptRevisionId,
        'originalPromptRevisionId': value.originalPromptRevisionId,
    };
}

